export default __webpack_public_path__ + "static/b_type_pdf-d203f63a0673c897cf27ed225702ac22.pdf";